module.exports = __webpack_public_path__ + "img/CUADRO_Esp-Tecnicas-DCU30.ddf43b10.png";